import { AccountProvider } from "./account";
import { AccountContext } from "./account-context";
import { useInheritContext } from "../../services/ContextForwarder";

const useAccount = () => useInheritContext("account", AccountContext);

export { AccountProvider, useAccount };
